<cdk-accordion class="accordion" id="accordionExample">
    <ng-container #fieldComponent></ng-container>
</cdk-accordion>
